import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Component that automatically adds the language query parameter
 * to all URLs when it's missing, ensuring language preference persists
 * across navigation
 */
const LanguageSync = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const langParam = searchParams.get('lang');
    const currentLang = i18n.language || 'en';

    // If there's no lang parameter in the URL, add it
    if (!langParam) {
      searchParams.set('lang', currentLang);
      const newUrl = `${location.pathname}?${searchParams.toString()}${location.hash}`;
      navigate(newUrl, { replace: true });
    }
    // If lang parameter exists but differs from i18n language, sync i18n
    else if (langParam !== i18n.language) {
      i18n.changeLanguage(langParam);
    }
  }, [location.pathname, location.search, location.hash, navigate, i18n]);

  return null; // This component doesn't render anything
};

export default LanguageSync;
